import type { DetailedHTMLProps, HTMLAttributes } from 'react'

import cn from 'clsx'
import { BlockQuote } from '@/components/Text/BlockQuote'

import { HyperLink } from '@/components/hyper-link/hyper-link'
import { Link } from '@/components/Link/Link'
import { Text } from '@/components/Text/Text'

import TwitterIcon from './twitter-icon.svg?react'

import css from './TweetCard.module.css'

type TweetImage = {
    src: string
    webp: string
}

export class Tweet {
    name: string
    username: string
    title: string
    quote: string
    image: TweetImage
    link: string

    constructor(
        name: string,
        username: string,
        title: string,
        quote: string,
        image: TweetImage,
        link: string,
    ) {
        this.name = name
        this.username = username
        this.title = title
        this.quote = quote
        this.image = image
        this.link = link
    }
}

export interface TweetCardProps
    extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    tweet: Tweet
}

export function TweetCard({ tweet, className, ...rest }: TweetCardProps) {
    return (
        <div className={cn(css.tweet, className)} {...rest}>
            <div className={css.tweetHead}>
                <HyperLink href={tweet.link} target="_blank" aria="Open on Twitter">
                    <TwitterIcon />
                </HyperLink>
                <BlockQuote size="quote-base">{tweet.quote}</BlockQuote>
            </div>

            <div className={css.author}>
                <picture>
                    <source srcSet={tweet.image.webp} type="image/webp" />
                    <img src={tweet.image.src} alt="Author avatar" />
                </picture>
                <div className={css.content}>
                    <Text size="body-sm">
                        {tweet.name}, {tweet.title}
                    </Text>
                    <Link
                        size="body-2xs"
                        href={`https://twitter.com/${tweet.username}`}
                        target="_blank"
                    >
                        @{tweet.username}
                    </Link>
                </div>
            </div>
        </div>
    )
}
